/*
 * Empowers the submenu. A little bit less
 * complicated than U1 so not using the
 * same logic
 *
 * @author BarrelNY
 *
 */
var Waypoints2 = {
	init:function(){

		var templates = [
			'body.neighborhood-template'
		].join();

		if (!$(templates).length) return;

		$('.current_page_item .sub-menu a, [data-trigger]')
			.on('click.waypoints', function(){

				var id  = $(this).attr('href')
				,   pos = $(id).position().top;

				$('html,body').stop().animate({scrollTop:pos - 100},1000);

				return false;
			})

		$(window).on('scroll.images',function(){

			var s = $(this).scrollTop()
			,   o = $('#gallery').position().top - $(this).height();

			if (s >= o){
				$('[data-delay-src]').each(function(){
					var $el = $(this)
					,   d   = $el.data('delay-src');

					$el.attr('data-src',d);
				});

				MUR.lazyload.init();
				$(window).off('scroll.images');
			}
		});

		$(window).trigger('scroll');
	},

	drop:function(){
		$('.current_page_item .sub-menu a')
			.off('click.waypoints');
	}
}

module.exports = Waypoints2;
